import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenService {
  private readonly tokenSignal = signal<string>('');

  readonly token = this.tokenSignal.asReadonly();

  setToken(token: string): void {
    this.tokenSignal.set(token);
  }
}
